import { useState, useEffect } from "react";
import { Dimensions } from "react-native";
import { LARGE_SCREEN_WIDTH } from "../constants/constants";

export const useScreenSize = () => {
  const [screenWidth, setScreenWidth] = useState(
    Dimensions.get("window").width,
  );

  useEffect(() => {
    const onChange = ({ window }: { window: { width: number } }) => {
      setScreenWidth(window.width);
    };

    const subscription = Dimensions.addEventListener("change", onChange);
    return () => subscription?.remove();
  }, []);

  return {
    LARGE_SCREEN: screenWidth > LARGE_SCREEN_WIDTH,
  };
};
